import { render, staticRenderFns } from "./AdministratorAction.vue?vue&type=template&id=4499d019&"
import script from "./AdministratorAction.vue?vue&type=script&lang=js&"
export * from "./AdministratorAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports